var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"fixed-anchor"},[_c('span',{staticStyle:{"top":"-200px"},attrs:{"id":_vm.identifier}})])}
var staticRenderFns = []

export { render, staticRenderFns }